import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { Symptoms } from './pages/Symptoms';
import { Care } from './pages/Care';
import { CarePathDetail } from './pages/CarePathDetail';
import { Library } from './pages/Library';
import { ArticleDetail } from './pages/ArticleDetail';
import { Circles } from './pages/Circles';
import { Treatments } from './pages/Treatments';
import { TreatmentDetail } from './pages/TreatmentDetail';
import { Testing } from './pages/Testing';
import { HowItWorks } from './pages/HowItWorks';
import { Pricing } from './pages/Pricing';
import { About } from './pages/About';
import { Start } from './pages/Start';
import { BrandProvider } from './contexts/BrandContext';
interface AppProps {
  /** Photographic hero, or a type-only validation statement. */
  heroVariant?: 'portrait' | 'statement';
  /** Whether the 3am plum band appears on the home page. */
  nightBand?: boolean;
}
export function App({
  heroVariant = 'portrait',
  nightBand = true
}: AppProps) {
  return <BrandProvider brandId="vesta" data-id="element-0" data-mp="3rcj5s04xxv5k">
      <BrowserRouter data-id="element-1" data-mp="3rdatypw7kqlt">
        <ScrollToTop data-id="element-2" data-mp="3rd1a7k1rbfok" />
        <div className="flex min-h-screen w-full flex-col bg-cream" data-id="element-3" data-mp="3relvsk63foaa">
          <Header data-id="element-4" data-mp="5gbv0xpxarn" />
          <Routes data-id="element-5" data-mp="82ohezguggq">
            <Route path="/" element={<Home heroVariant={heroVariant} nightBand={nightBand} data-id="element-7" data-mp="2zmo4d53t6f0j" />} data-id="element-6" data-mp="2zld1d7i6tbah" />
            <Route path="/symptoms" element={<Symptoms data-id="element-9" data-mp="33orhrza1ftog" />} data-id="element-8" data-mp="33nq9g2keplaf" />
            <Route path="/care" element={<Care data-id="element-11" data-mp="38li619vzxvky" />} data-id="element-10" data-mp="38m1g64fenfof" />
            <Route path="/care/:slug" element={<CarePathDetail data-id="element-13" data-mp="38o4ct7b2c724" />} data-id="element-12" data-mp="38k6v8q44vnkc" />
            <Route path="/library" element={<Library data-id="element-15" data-mp="3dmfpdpsqsvo1" />} data-id="element-14" data-mp="3dl4l7ovdxlwe" />
            <Route path="/library/:slug" element={<ArticleDetail data-id="element-17" data-mp="nwc39wy9i3yd" />} data-id="element-16" data-mp="3dii530ufhy2k" />
            <Route path="/circles" element={<Circles data-id="element-19" data-mp="nxx0jubyo0zx" />} data-id="element-18" data-mp="nv0wrpdfmi3k" />
            <Route path="/treatments" element={<Treatments data-id="element-21" data-mp="st2h0dmlgngm" />} data-id="element-20" data-mp="su43de928wdn" />
            <Route path="/treatments/:slug" element={<TreatmentDetail data-id="element-23" data-mp="35ozsypftiwt" />} data-id="element-22" data-mp="swgk5o3310p4" />
            <Route path="/testing" element={<Testing data-id="element-25" data-mp="3uct43lu76r1j" />} data-id="element-24" data-mp="34x4lozr5n72" />
            <Route path="/how-it-works" element={<HowItWorks data-id="element-27" data-mp="3uc9i9u1ffii8" />} data-id="element-26" data-mp="3udazyhcy738x" />
            <Route path="/pricing" element={<Pricing data-id="element-29" data-mp="d57d4waue6fw" />} data-id="element-28" data-mp="3uf5g7id9y76o" />
            <Route path="/about" element={<About data-id="element-31" data-mp="d2l7513lnyzs" />} data-id="element-30" data-mp="d3cwvvain2i5" />
            <Route path="/start" element={<Start data-id="element-33" data-mp="86mev2f5hwu3" />} data-id="element-32" data-mp="85uivqhn5x3a" />
            <Route path="*" element={<Home heroVariant={heroVariant} nightBand={nightBand} data-id="element-35" data-mp="3gkv0fqj99ncr" />} data-id="element-34" data-mp="864djrdmssfb" />
          </Routes>
          <Footer data-id="element-36" data-mp="3bmthr6pqrq1t" />
        </div>
      </BrowserRouter>
    </BrandProvider>;
}
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return null;
}